export default {
  DiamondDrill: 1, 
  Directional: 2,
  DownTheHoleHammer : 3,
  RotaryAirBlast : 4,
  ReverseCirculation : 5,
  Sludge : 6,
  Soil : 7,
  Sonic : 8,
  BlastHole : 9,
  Unknown : 99
};